import { GAME_MAPS, type MapId } from './worldMaps';
export function worldRoute(from: MapId, to: MapId): MapId[] {
  const queue: MapId[][] = [[from]], visited = new Set<MapId>([from]);
  while (queue.length) {
    const route = queue.shift()!, last = route.at(-1)!;
    if (last === to) return route;
    for (const portal of GAME_MAPS[last].portals) {
      if (visited.has(portal.target)) continue;
      visited.add(portal.target); queue.push([...route, portal.target]);
    }
  }
  return [];
}

export function worldMapDiagram(current:MapId):string {
 const positions={} as Record<MapId,[number,number]>;Object.values(GAME_MAPS).forEach((map,i)=>{positions[map.id]=[110+(i%5)*210,70+Math.floor(i/5)*110];});
 const seen=new Set<string>(),roads:string[]=[];
 for(const map of Object.values(GAME_MAPS))for(const portal of map.portals){const key=[map.id,portal.target].sort().join(':');if(seen.has(key))continue;seen.add(key);const [x1,y1]=positions[map.id],[x2,y2]=positions[portal.target];roads.push(`<path d="M${x1},${y1} L${x2},${y2}" stroke="#927749" stroke-width="4" fill="none"/>`);}
 const nodes=Object.values(GAME_MAPS).map(map=>{const [x,y]=positions[map.id];return `<g><circle cx="${x}" cy="${y}" r="20" fill="${map.id===current?'#d3af61':map.safe?'#56856a':'#634851'}" stroke="#e7cf96" stroke-width="2"/><text x="${x}" y="${y+5}" text-anchor="middle" fill="#fff5d2" font-size="15">${map.safe?'⌂':'◆'}</text><text x="${x}" y="${y+43}" text-anchor="middle" fill="#f1deb8" font-size="15">${map.name}</text></g>`;}).join('');
 return `<div class="world-map-canvas"><svg viewBox="0 0 1080 ${Math.ceil(Object.keys(GAME_MAPS).length/5)*110+30}" role="img" aria-label="พื้นที่และเส้นทางเดินทาง พร้อมเส้นทางเชื่อมจริง" xmlns="http://www.w3.org/2000/svg">${roads.join('')}${nodes}</svg></div>`;
}
